import { Box, Button, Grid, Paper, Typography } from '@mui/material';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '../../store/hooks';

import "./pageNotFound.scss";

const PageNotFound = () => {

    const navigate = useNavigate()

    const { user_key, userInfo } = useAppSelector(state => state.loginStore)

    const handleClick = () => {
        user_key.length ?
            ((userInfo && userInfo.role !== "User") ? navigate("/admin/accounts") : navigate("/accounts"))
            : navigate("/login")
    }

    return (
        <Box className="page-not-found-main">
            <Box className="page-not-found">
                <Typography variant="h4">
                    404
                </Typography>
                <Typography variant="h5">
                    Page not found
                </Typography>
                <Typography variant="subtitle1"

                >
                    Please click on below button to redirect home page
                </Typography>
                <Button className='page-not-found-button'
                    aria-label="home"
                    color='primary'
                    variant="contained"
                    fullWidth
                    onClick={handleClick}
                >
                    <ArrowBackIosNewIcon /> Go Back
                </Button>
            </Box>
        </Box>
    )
}

export default PageNotFound